export const MEDIA_FILE_IDS = {
    VIDEO: 'VIDEO',
    AUDIO: 'AUDIO',
    CV: 'CV',
    PRESENTATION: 'PRESENTATION',
    RESUME: 'RESUME',
    DOCUMENT: 'DOCUMENT'
}